export default "__VITE_ASSET__D8TV3OHI__"